import { IconFreeShippingListPage } from '@/icons/IconFreeShippingListPage';
import React from 'react';

function ShowFreeShippingBanner({ show }: { show: boolean }) {
  return (
    show && (
      <div className="relative left-1/2 right-1/2 -mx-[50vw] mb-4 w-screen">
        <div className="flex items-center justify-center gap-x-3 bg-black py-2">
          <p className="text-xl font-medium text-white">All of these product are available for free shipping</p>
          <div className="flex items-center gap-x-2 rounded-lg bg-[#2563EB] p-3">
            <IconFreeShippingListPage className="h-5 w-5" />
            <p className="text-lg font-medium text-white">Free Shipping</p>
          </div>
        </div>
      </div>
    )
  );
}

export default ShowFreeShippingBanner;
